import { Mic, Square } from 'lucide-react';
import { IconButton, type IconButtonProps } from '@/components/ui';
import { cn } from '@/lib/utils';
import type { Dictation } from './useDictation';
import './MicButton.css';

export interface MicButtonProps {
  dictation: Dictation;
  size?: IconButtonProps['size'];
  disabled?: boolean;
  className?: string;
}

/**
 * O botão do microfone: um toque grava (pulsando, `aria-pressed`), outro para e
 * transcreve (girando). Some num navegador que não grava áudio — um botão que só
 * explica que não funciona é ruído no compositor.
 */
export function MicButton({ dictation, size = 'md', disabled, className }: MicButtonProps): JSX.Element | null {
  if (!dictation.supported) return null;
  const recording = dictation.state === 'recording';
  return (
    <IconButton
      size={size}
      label={recording ? 'Parar e transcrever' : 'Ditar a pergunta'}
      icon={recording ? <Square /> : <Mic />}
      aria-pressed={recording}
      loading={dictation.state === 'transcribing'}
      disabled={disabled && !recording}
      onClick={dictation.toggle}
      className={cn('mic-button', recording && 'mic-button--recording', className)}
    />
  );
}
